import app from 'flarum/forum/app';
import EventPost from 'flarum/forum/components/EventPost';
import ItemList from 'flarum/common/utils/ItemList';
import Button from 'flarum/common/components/Button';
import Handler from '../Checkout/Handler';
export default class PtvRequiresPayment extends EventPost {
  descriptionKey() {
    return 'floxum-payments.forum.pay-to-view.description';
  }
  descriptionData() {
    return {};
  }
  icon() {
    return 'fas fa-shopping-cart';
  }
  checkout() {
    const discussion = this.attrs.post.discussion().id();
    const handler = new Handler('ptv', {
      discussion
    });
    handler.checkout();
  }
  footerItems() {
    const items = new ItemList();
    if (!app.session?.user) {
      items.add('payToView', m("div", {
        className: "Button Button--rounded",
        onclick: () => app.modal.show(() => flarum.reg.asyncModuleImport('flarum/forum/components/LogInModal'))
      }, app.translator.trans('floxum-payments.forum.pay-to-view.purchase-log-in')));
    } else if (this.attrs.post.discussion().blomstraPtvPaid()) {
      items.add('payToView', m("div", {
        className: "Button Button--rounded disabled completed"
      }, app.translator.trans('floxum-payments.forum.pay-to-view.purchase-completed')));
    } else {
      items.add('payToView', m(Button, {
        onclick: () => this.checkout(),
        className: "Button Button--rounded"
      }, app.translator.trans('floxum-payments.forum.pay-to-view.purchase-control')));
    }
    return items;
  }
  actionItems() {
    return new ItemList();
  }
}
flarum.reg.add('floxum-payments', 'forum/Post/PtvRequiresPayment', PtvRequiresPayment);